import React from "react";
import ReactDOM from "react-dom/client";

import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';


function Main() {
    return (
        <App/>
    );
}

// const rootElement = document.getElementById("root");
// ReactDOM.render(<Main />, rootElement);

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(<App />);

serviceWorkerRegistration.register();
